// images
import blogImg1 from "../images/blog/banner1.jpg";
import blogImg2 from "../images/blog/banner2.jpg";
import blogImg3 from "../images/blog/banner3.jpg";

import blogImg4 from "../images/blog/img-4.jpg";
import blogImg5 from "../images/blog/img-5.jpg";
import blogImg6 from "../images/blog/img-6.jpg";

import blogImg7 from "../images/blog/img-7.jpg";
import blogImg8 from "../images/blog/img-8.jpg";
import blogImg9 from "../images/blog/img-9.jpg";

import blogImg10 from "../images/blog/img-10.jpg";
import blogImg11 from "../images/blog/img-11.jpg";
import blogImg12 from "../images/blog/img-12.jpg";

import blogImg13 from "../images/blog/img-13.jpg";
import blogImg14 from "../images/blog/img-14.jpg";
import blogImg15 from "../images/blog/img-15.jpg";

import blogAvaterImg1 from "../images/blog/blog-avater/img-1.jpg";
import blogAvaterImg2 from "../images/blog/blog-avater/img-2.jpg";
import blogAvaterImg3 from "../images/blog/blog-avater/img-3.jpg";

import blogSingleImg1 from "../images/blog/1.jpg";
import blogSingleImg2 from "../images/blog/2.jpg";
import blogSingleImg3 from "../images/blog/3.jpg";

import blogSingleImg4 from "../images/blog/4.jpg";
import blogSingleImg5 from "../images/blog/5.jpg";
import blogSingleImg6 from "../images/blog/6.jpg";

import blogSingleImg7 from "../images/blog/7.jpg";
import blogSingleImg8 from "../images/blog/8.jpg";
import blogSingleImg9 from "../images/blog/9.jpg";

import blogSingleImg10 from "../images/blog/10.jpg";
import blogSingleImg11 from "../images/blog/11.jpg";
import blogSingleImg12 from "../images/blog/12.jpg";

import blogSingleImg13 from "../images/blog/13.jpg";
import blogSingleImg14 from "../images/blog/14.jpg";
import blogSingleImg15 from "../images/blog/15.jpg";



const blogs = [
  {
    id: '1',
    title: 'Guidance on Financial Transactions',
    screens: blogImg1,
    description: `
        <p>Surah Al-Baqarah, the second chapter of the Quran, holds profound wisdom and guidance for believers. In Ayah 279, Allah addresses the believers, emphasizing the significance of refraining from engaging in interest-based transactions or usury.</p>
      
        <p>The verse begins with the words "<span lang="ar" style="font-style:italic;">يَا أَيُّهَا الَّذِينَ آمَنُوا</span>" (O you who have believed), capturing the attention of those who have embraced faith. This signals that the guidance given is specifically for the believers who strive to follow the righteous path.</p>
      
        <p>The alternative proposed in the ayah is to "<span lang="ar" style="font-style:italic;">وَذَرُوا مَا بَقِيَ مِنَ الرِّبَا إِن كُنتُم مُّؤْمِنِينَ</span>" (give up what remains [due to you] of interest if you are [indeed] believers). Believers are encouraged to abandon the gains acquired through usurious means and instead engage in fair trade and transactions that uphold justice.</p>
      
        <p>The ayah continues with a stern warning against involvement in usury, urging believers to abandon such practices and offering a clear alternative: "<span lang="ar" style="font-style:italic;">فَإِن لَّم تَفْعَلُوا فَأْذَنُوا بِحَرْبٍ مِّنَ اللَّهِ وَرَسُولِهِ</span>" (And if you do not, then be informed of a war [against you] from Allah and His Messenger).</p>
      
        <p>This verse underscores the severity of engaging in usury, equating it with a declaration of war against Allah and His Messenger. It serves as a potent reminder of the spiritual and ethical consequences associated with financial transactions that exploit others through interest.</p>
      
        <p>Understanding the historical context is crucial. During the time of the revelation, the Arabian society was deeply entangled in usurious practices, exploiting the vulnerable and perpetuating economic injustices. The guidance in Surah Al-Baqarah aimed to transform the economic landscape and establish justice in financial dealings.</p>
      
        <p>This ayah highlights Islam's emphasis on economic justice. It encourages believers to be conscious of their financial dealings, ensuring that they align with ethical principles and contribute to the welfare of society.</p>
      
        <p>In conclusion, Surah Al-Baqarah (2:278-279) provides a powerful message on the prohibition of usury, stressing the need for believers to prioritize ethical financial practices. By abandoning interest-based transactions and embracing fair trade, Muslims can contribute to building a just and compassionate economic system, aligning their actions with the teachings of the Quran.</p>
            `,
    authorTitle: 'volunteer',
    authorImg: blogAvaterImg1,
    create_at: '28 FEB,24',
    blogSingleImg: blogSingleImg1,
    comment: '0',
    blClass: 'format-standard-image',
  },
  {
    id: '2',
    title: 'The Serious Warning Against Usury in Islam',
    screens: blogImg2,
    description: `        <div>
  <h2>Introduction:</h2>
  <p>
    Islamic teachings strongly oppose the practice of usury or interest. This moral and economic principle is clearly stated in a saying by Jabir (may Allah be pleased with him) in Sahih Muslim (1598). This saying highlights the seriousness of engaging in usurious transactions and those involved in them.
  </p>

  <h2>The Hadith:</h2>
  <p>
    According to Jabir, Allah's Messenger (ﷺ) invoked Allah's curse upon those who accept interest, those who pay it, those who record it, and the witnesses. He emphasized, "They are all equal."
  </p>

  <h2>Understanding the Implications:</h2>

  <p>
    This saying emphasizes the gravity of dealing with interest, portraying it not just as a financial matter but as an action that displeases Allah. Prophet Muhammad (ﷺ) equates the different roles in a usurious transaction, stressing shared responsibility in sustaining an unjust system.
  </p>

  <ol>
    <li>
      <h3>The Accepter of Interest:</h3>
      <p>
        Those willingly engaging in usury, whether individuals or institutions, are condemned for actively participating in an unethical practice. This underscores the importance of personal accountability in financial matters.
      </p>
    </li>

    <li>
      <h3>The Payer of Interest:</h3>
      <p>
        The saying condemns not only those who receive interest but also those who willingly pay it, addressing the root of the problem and discouraging participation in transactions violating Islamic Financial principles.
      </p>
    </li>

    <li>
      <h3>The Recorder of Interest:</h3>
      <p>
        Those documenting interest transactions are not exempt from the curse, emphasizing Islam's holistic approach to justice—discouraging every step contributing to an unjust economic system.
      </p>
    </li>

    <li>
      <h3>The Two Witnesses:</h3>
      <p>
        Even witnesses attesting to the legitimacy of usurious transactions are held accountable. This serves as a reminder that the community should actively discourage and prevent such transactions instead of being passive spectators.
      </p>
    </li>
  </ol>

  <h2>The Equality of Blame:</h2>
  <p>
    The Prophet's statement, "They are all equal," rejects any notion of guilt hierarchy. Every individual involved in a usurious transaction shares equal responsibility, emphasizing the collective duty to eliminate this societal ill.
  </p>

  <h2>Conclusion:</h2>
  <p>
    This saying serves as a strong reminder for Muslims to conscientiously avoid involvement in usury, whether as a participant, recorder, or witness. It urges believers to follow and prioritize Islamic Financial laws and promotes a unified stand against economic practices that exploit others. Reflecting on these teachings, let us strive to build an economic system aligning with the ethical principles laid out by Prophet Muhammad (ﷺ) and embodying the true spirit of justice in Islam.
  </p>
</div>
`,
    author: 'Konal Biry',
    authorTitle: 'volunteer',
    authorImg: blogAvaterImg2,
    create_at: '16 AUG,21',
    blogSingleImg: blogSingleImg2,
    comment: '80',
    blClass: 'format-standard-image',
  },
  {
    id: '3',
    title: 'Embracing Balance and Gratitude',
    screens: blogImg3,
    description: `        <div>
<h2>Coming soon...</h2>
</div>
`,
    author: 'Konal Biry',
    authorTitle: 'volunteer',
    authorImg: blogAvaterImg2,
    create_at: '16 AUG,21',
    blogSingleImg: blogSingleImg2,
    comment: '80',
    blClass: 'format-standard-image',
  },
];
export default blogs;